var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"master-layout background-color-gray"},[_c('PrivacyModal'),_c('Auth_Screens'),_c('TopNav',[_vm._t("sticky-header")],2),_c('Map_Sidebar'),_c('div',{staticClass:"main-container",class:_vm.$mq},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }